export default "__VITE_ASSET__OgcqvinM__"